import React, { Fragment } from 'react'
import { TxtLink } from 'atoms/Texts'
import Icon from 'atoms/Icon'

export const actionFormatter2 = (cell, row, rowIndex, formatExtraData) => {
  const { save, del, allowSave, allowDel } = formatExtraData
  return (
    <div>
      {row.isNew ?
        <Fragment>
          {allowSave &&
            <TxtLink weight={'bold'} href={'#'} onClick={save(row)}>
              Save
            </TxtLink>
          }
        </Fragment> :
        <Fragment>
          {allowDel &&
            <Icon icon={'trash-alt'} ml={'0%'} color={'red'} onClick={del(row)} showPointer={true} />
          }
        </Fragment>
      }
    </div>
  )
}
